import actionTypes from '../constants/action-types';
import steps from '../constants/step-constants';

const initialState = {
  activeStep: steps.INVOICE_DETAILS,
  isSignInComplete: false,
  isInvoiceComplete: false,
  isPaymentComplete: false,
};

export default (state = initialState, action) => {
  const { type, ...other } = action;

  switch (type) {
    case actionTypes.RESET_APP:
      return initialState;
    case actionTypes.UPDATE_STEP:
      return {
        ...state,
        ...other,
      };
    case actionTypes.RESET_STEP_SIGN_IN:
      return {
        ...state,
        isSignInComplete: false,
      };
    case actionTypes.RESET_STEP_INVOICE:
      return {
        ...state,
        isInvoiceComplete: false,
      };
    case actionTypes.RESET_STEP_PAYMENT:
      return {
        ...state,
        isPaymentComplete: false,
      };
    default:
      return state;
  }
};
